import React, { FC, useEffect, useState } from 'react';
import axios from 'axios';

import { useStamps } from '../../lib/stamps';
import { UserPage } from "components/UserPage"
import { Section } from "components/Section"

type Stamp = {
    id: number,
    number: number,
    text: string,
    date: string,
    genere: string,
    href?: string,
};

type PagerProps = {
    pager: { current: number, prev: number, next: number };
    onPaging: (page: number) => void;
};

const Pager: FC<PagerProps> = ({ pager, onPaging }) => {
    return <>
        <div className="pager">
            {pager.prev > 0 ? (
                <a className="arrow" onClick={() => onPaging(pager.prev)}>&lt;</a>
            ) : (
                <span className="arrow -inactive">&lt;</span>
            )}
            {pager.current > 0 && <span className="current">{pager.current}枚目</span>}
            {pager.next > 0 ? (
                <a className="arrow" onClick={() => onPaging(pager.next)}>&gt;</a>
            ) : (
                <span className="arrow -inactive">&gt;</span>
            )}
        </div>

        <style jsx>{`
        .pager {
            display: flex;
            margin-bottom: 1em;
            color: #ffffff;
        }
        .pager > .current {
            flex-grow: 1;
            font-size: 0.8rem;
            text-align: center;
        }
        .pager > .arrow {
            flex-grow: 0;
            cursor: pointer;
        }
        .pager > .arrow.-inactive {
            visibility: hidden;
        }
        `}</style>
    </>;
};


const StampLandingPage: FC = () => (
    <Section fillOnSp>
        <div className="wrapper">
            <div className="head">
                <div className="title">
                    <div className="slash left"></div>
                    <span className="text-wrapper">
                        <span className="line-wrapper">
                            <span className="large">サロンメンバー</span>の<span className="large">お店</span>を訪れて<br />
                        </span>
                        <span className="line-wrapper">
                            <span className="large">スタンプ</span>を<span className="medium">貯めよう！</span>
                        </span>
                    </span>
                    <div className="slash right"></div>
                </div>
                <div className="speech-balloon-wrapper">
                    <img className="background-stars right pc" src="/img/pc_stars_right.png" />
                    <img className="background-stars left pc" src="/img/pc_stars_left.png" />
                    <img className="background-stars right sp" src="/img/sp_stars_right.png" />
                    <img className="background-stars left sp" src="/img/sp_stars_left.png" />
                    <div className="balloon-container top">
                        <div className="balloon">近所のお店をコンプリートしよう！</div>
                    </div>
                    <div className="balloon-container bottom">
                        <div className="balloon">スタンプカードを充実させよう！</div>
                    </div>
                </div>
                <div className="description">
                    <span className="caution">
                        ※こちらのサービスは西野亮廣エンタメ研究所に入会している<br />
                        サロンメンバーの皆さんがご利用いただけるサービスです。 <br />
                        まだ入会していない方は<a href="/payments/pay/nishino">こちら</a>
                    </span>
                </div>
            </div>
            <div className="contents">
                <h2>スタンプをGETできる方法</h2>
                <div className="contents-wrapper">
                    <section className="content-wrapper">
                        <h3>店内に設置されたQRコードを読み込む</h3>
                        <div className="content">
                            <div className="sample-image">
                                <img className="phone_icon" src="/img/phone_icon.png" />
                                <img src="/img/qr_sample.png" />
                            </div>
                            <p>QRコードを店内に設置しているお店であれば店内でQRコードを読み込むことでそのお店のスタンプをGETすることができます。</p>
                        </div>
                    </section>
                    <section className="content-wrapper">
                        <h3>「今日のスタンプ」ボタンをクリック</h3>
                        <div className="content">
                            <div className="sample-image">
                                <img src="/img/howto_todays_stamp.png" />
                            </div>
                            <p>お店に近づいた際「今日のスタンプ」ボタンがお店詳細画面に表示されるので、そのボタンを押していただくことでスタンプをGETすることができます。</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <style jsx>{`
            .wrapper {
                padding-top: 28px;
                padding-bottom: 26px;
            }
            .head {}
            .head > .title {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 20px;
            }
            .title > .slash {
                width: 3px;
                height: 100px;
                background-color: #ff6e00;
            }
            .title > .slash.left {
                transform: rotate(-18deg);
                margin-right: 40px;
            }
            .title > .slash.right {
                transform: rotate(18deg);
                margin-left: 40px;
            }
            .title > .text-wrapper {
                color: #ff6e00;
                font-size: 29px;
                font-weight: 700;
                text-align: center;
            }
            .text-wrapper > .line-wrapper {
                background: linear-gradient(#fff 10%, #fff0e5 60%);
            }
            .text-wrapper > .line-wrapper > .large {
                font-size: 45px;
            }
            .text-wrapper > .line-wrapper > .medium {
                font-size: 39px;
            }
            .head > .speech-balloon-wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 12px;
                position: relative;
            }
            .background-stars {
                position: absolute;
            }
            .sp {
                display: none; 
            }
            .background-stars.right {
                right: 0;
            }
            .background-stars.left {
                left: 0;
            }
            .speech-balloon-wrapper > .balloon-container {
            }
            .balloon-container.top {
                margin-bottom: 8px;
            }
            .balloon {
                position: relative;
            }
            .balloon-container.top > .balloon {
                margin-right: 50px;
            }
            .balloon-container.top > .balloon::before {
                content: "";
                position: absolute;
                top: 50%;
                left: calc(100% - 1px);
                margin-top: -8px;
                border: 8px solid transparent;
                border-left: 20px solid #ff6d00;
            }
            .balloon-container.bottom > .balloon {
                margin-left: 50px;
            }
            .balloon-container.bottom > .balloon::before {
                content: "";
                position: absolute;
                top: 50%;
                right: calc(100% - 1px);
                margin-top: -8px;
                border: 8px solid transparent;
                border-right: 20px solid #ff6d00;
            }
            .balloon-container > .balloon {
                width: 480px;
                height: 50px;
                background-color: #ff6d00;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-size: 22px;
                font-weight: bold;
                padding: 14px 22px;
            }
            .head > .description {
                font-size: 14px;
                margin: 0 46px 20px 46px;
                text-align: center;
            }
            .description > .caution > a {
                color: #ff6e00;
            }
            .contents {
                display: flex;
                flex-direction: column;
                justify-content center;
                align-items: center;
            }
            .contents-wrapper > h2 {
                font-size: 19px;
            }
            .contents-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
            }
            .contents-wrapper > .content-wrapper {
                width: 330px;
                height: 272px;
                padding: 22px 26px;
                border-radius: 20px;
                background-color: rgba(255, 109, 0, 0.13);
                margin-bottom: 30px;
                margin-right: 15px;
                margin-left: 15px;
            }
            .content-wrapper > h3 {
                font-size: 14px;
                color: #ff6e00;
                text-align: center;
                margin-top: 0;
            }
            .content {
                display: flex;
                justify-content: space-between;
                align-items: start;
            }
            .content > .sample-image {
                position: relative;
                width: 150px;
                height: 195px;
                background: #fff;
            }
            .sample-image > img:not(.phone_icon) {
                height: 195px;
            }
            .sample-image > .phone_icon {
                position: absolute;
                right: -50px;
                bottom: -20px;
            }
            .content > p {
                width: 110px;
                padding-top: 15px;
                font-size: 10.5px;
            }
            @media screen and (max-width: 1330px) {
                .background-stars {
                    max-width: 110px;
                }
            }
            @media screen and (max-width: 1200px) {
                .background-stars {
                    max-width: 90px;
                }
            }
            @media screen and (max-width: 730px) {
                .title > .slash {
                    width: 2px;
                    height: 50px;
                }
                .title > .slash.left {
                    transform: rotate(-18deg);
                    margin-right: 20px;
                }
                .title > .slash.right {
                    transform: rotate(18deg);
                    margin-left: 20px;
                }
                .title > .text-wrapper {
                    font-size: 14px;
                }
                .text-wrapper > .line-wrapper > .large {
                    font-size: 22px;
                }
                .text-wrapper > .line-wrapper > .medium {
                    font-size: 19px;
                }
                .balloon-container.top > .balloon {
                    margin-right: 25px;
                }
                .pc {
                    display: none;
                }
                .sp {
                    display: inline;
                }
                .background-stars {
                    max-width: 50px;
                }
                .background-stars.right {
                    right: 10px;
                }
                .background-stars.left {
                    left: 10px;
                }
                .balloon-container.top > .balloon::before {
                    margin-top: -5px;
                    border: 5px solid transparent;
                    border-left: 12px solid #ff6d00;
                }
                .balloon-container.bottom > .balloon {
                    margin-right: 25px;
                }
                .balloon-container.bottom > .balloon::before {
                    margin-top: -5px;
                    border: 5px solid transparent;
                    border-right: 12px solid #ff6d00;
                }
                .balloon-container > .balloon {
                    width: 240px;
                    height: 25px;
                    font-size: 14px;
                    padding: 5px 8px;
                }
                .head > .description {
                    font-size: 10px;
                    text-align: left;
                }
            }
        `}</style>
    </Section>
);


type Props = {};

export const StampCardPage: FC<Props> = (props) => {
    // @ts-ignore
    const id = props.match.params.id;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [stamps, setStamps] = useState<(Stamp | null)[]>([]);
    const [pager, setPager] = useState({ current: 0, prev: 0, next: 0 });
    const [name, setName] = useState('');
    const [load, setLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stamp, setStamp] = useState<Stamp | null>(null);
    const { getCard } = useStamps();

    const stampIcons = {
        '飲食店': '/img/map_stamp_icons/stamp-rest.png',
        'ヘアサロン': '/img/map_stamp_icons/stamp-cut.png',
        'スナックキャンディ': '/img/map_stamp_icons/stamp-candy.png',
        '宿泊': '/img/map_stamp_icons/stamp-hotel.png',
        'その他': '/img/map_stamp_icons/stamp-other.png',
        '自販機': '/img/map_stamp_icons/stamp-vend.png',
        '居酒屋・バー': '/img/map_stamp_icons/stamp-bar.png',
        'レストラン・カフェ': '/img/map_stamp_icons/stamp-cafe.png',
        'スイーツ': '/img/map_stamp_icons/stamp-sweets.png',
        '健康': '/img/map_stamp_icons/stamp-health.png',
        '医療・福祉': '/img/map_stamp_icons/stamp-medical.png',
        '小売': '/img/map_stamp_icons/stamp-retail.png',
        'エンタメ・レジャー': '/img/map_stamp_icons/stamp-entertainment.png',
        '習いごと': '/img/map_stamp_icons/stamp-education.png',
        'ビューティ': '/img/map_stamp_icons/stamp-beauty.png',
        'レンタルスペース': '/img/map_stamp_icons/stamp-rentalspace.png',
        'ビジネス': '/img/map_stamp_icons/stamp-buisiness.png',
        '保育園・幼稚園': '/img/map_stamp_icons/stamp-nursery.png',
        '農業': '/img/map_stamp_icons/stamp-agri.png',
    };

    useEffect(() => {
        async function initialize() {
            await paging();
            setLoad(true);
        }
        initialize();
    }, []);

    const formatDate = (date: string) => {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = ('0' + (d.getMonth() + 1)).slice(-2);
        const dd = ('0' + d.getDate()).slice(-2);
        return `${yyyy}.${mm}.${dd}`;
    };

    const paging = async (page?: number) => {
        const { card, stamps, pager } = await getCard(id, page);
        if (card && card.type === 1) {
            setName(stamps[0].spot.name);
        };
        setPager(pager);
        setStamps(fillEmptyCells(
            stamps,
            card === null || card === undefined,
        ));
    };

    const fillEmptyCells = (stamps: [], isMixed = true) => {
        if (stamps.length === 0) {
            return (new Array(10)).fill(null);
        }
        return stamps.map((stamp: any) => {
            if (!stamp) {
                return null;
            }
            const s = {
                id: stamp.id,
                number: stamp.spot_id,
                text: isMixed ? stamp.spot.name : null,
                date: formatDate(stamp.created),
                href: isMixed ? `/map/stampcard/${stamp.spot_id}` : null,
                genre: stamp.spot.spot_genre.genre,
            };
            return stamp ? s : null;
        });
    };

    if (!load) {
        return <UserPage title="Salon.jp | スタンプカード"></UserPage>
    };

    return (
        <UserPage title="Salon.jp | スタンプカード">
            {stamps.every((stamp) => !stamp)
                ? <StampLandingPage />
                : (
                    <Section fillOnSp={true}>
                        <div className={['wrap', name ? '-spot' : ''].join(' ')}>
                            <div className="title">
                                {name ? (
                                    <h1>
                                        <span className="main">{name}</span><br /><span className="sub">スタンプカード</span>
                                    </h1>
                                ) : (
                                    <h1>
                                        <span className="em">サロンメンバー</span><span className="small">の</span>
                                        <span className="em">お店</span><span className="small">を訪れて</span><br />
                                        <span className="em">スタンプ</span><span className="small">を</span><span className="em">貯めよう!</span>
                                    </h1>
                                )}
                            </div>

                            {pager && <Pager pager={pager} onPaging={paging} />}

                            <div className="stampcard-wrap">
                                <div className="stampcard">
                                    {stamps.map((stamp, idx) => {
                                        return (
                                            <div className="stamp">
                                                {!stamp ? (
                                                    <span className="number">{idx + 1}</span>
                                                ) : (
                                                    <a href={stamp.href}>
                                                        {/* @ts-ignore */}
                                                        <img className="mark" src={stampIcons[stamp.genre]} />
                                                    </a>
                                                )}
                                                {!stamp?.href && <span className="date">{stamp?.date}</span>}
                                                {stamp?.href && (
                                                    <a className="text-wrapper" href={stamp?.href}>
                                                        <span className="text">{stamp?.text}</span>
                                                        <span className="date">{stamp?.date}</span>
                                                    </a>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="manage-stamp-button-container">
                                <a className="manage-stamp-button" href={id ? `/map/stamps/${id}/edit` : '/map/stamps/edit'}>
                                    スタンプを管理する
                                </a>
                            </div>
                        </div>

                        <style jsx>{`
                            .title {
                                display: flex;
                                justify-content: center;
                                padding-top: 20px;
                                padding-bottom: 20px;
                                text-align: center;
                                color: #ffffff;
                            }
                            .title > h1 {
                                margin: 0;
                                line-height: 1;
                            }
                            .title::before,
                            .title::after {
                                content: "";
                                display: block;
                                width: 2px;
                                height: 50px;
                                background: #ffffff;
                            }
                            .title::before {
                                margin-right: 1rem;
                                transform: skew(20deg);
                            }
                            .title::after {
                                margin-left: 1rem;
                                transform: skew(-20deg);
                            }
                            .em {
                                font-size: 1.2rem;
                                font-weight: bold;
                            }
                            .small {
                                font-size: 0.7rem;
                            }
                            .main {
                                font-size: 1.2rem;
                            }
                            .sub {
                                font-size: 0.9rem;
                            }
                            .wrap {
                                padding: 15px;
                                background: #ed7c4f;
                            }
                            .wrap.-spot {
                                background: #f1bd3f;
                            }
                            .wrap.-spot > .title::before,
                            .wrap.-spot > .title::after {
                                width: 0;
                            }
                            .wrap.-spot .stamp {
                                border: 1px dashed #f1bd3f;
                            }
                            .wrap.-spot .number {
                                color: #f7de9f;
                            }
                            .stampcard-wrap {
                                border-radius: 30px;
                                overflow: hidden;
                            }
                            .stampcard {
                                display: grid;
                                grid-template-columns: repeat(2, minmax(50px, 1fr));
                                margin: -4px;
                                border: 3px solid transparent;
                            }
                            .stamp {
                                display: flex;
                                align-items: center;
                                padding: 0.5rem;
                                min-height: 120px;
                                justify-content: center;
                                flex-direction: column;
                                border: 1px dashed #ed7c4f;
                                background: #ffffff;
                                position: relative;
                            }
                            .text-wrapper {
                                text-decoration: none;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                            }
                            .text,
                            a.text:link,
                            a.text:visited,
                            a.text:hover,
                            a.text:active {
                                color: #ed7c4f;
                                font-size: 0.8rem;
                                font-weight: bold;
                                text-decoration: underline;
                            }
                            .date {
                                color: #ed7c4f;
                                font-size: calc(0.8rem - 1px);
                            }
                            .number {
                                color: #f7cab8;
                                font-size: 2em;
                            }
                            .mark {
                                display:block;
                                transition: ease-out 1s;
                            }
                            .mark.-big {
                                opacity: 0.2;
                                transform: scale(3, 3);
                            }
                            .manage-stamp-button-container {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin: 10px 0px;
                            }
                            .manage-stamp-button {
                                color: #fff;
                                font-size: 15px;
                                text-align: center;
                                background: none;
                                border: none;
                            }
                        `}</style>
                    </Section>
                )}
        </UserPage>
    );
};
